<template>
    <layout-dashboard-2 style="padding-top: 1.5rem">
        <template #widget-0>
            <v-layout style="height: 100%">
                <v-flex xs3>
                    <app-widget-performance
                        :title="$t('aua') + ' (' + $t('current_value') + ')'"
                        :value="
                            toCurrency(
                                readStat('AUA.current.amount', 0),
                                readStat('AUA.current.currency', 'GBP'),
                                0,
                                true
                            )
                        "
                        :aside="[
                            `${toPercentage(readStat('AUA.month', 0), 0)} ${$t('this_month')}`,
                            `${toPercentage(readStat('AUA.year', 0), 0)} ${$t('this_year')}`
                        ]"
                        :loading="loading.statistics"
                    />
                </v-flex>
                <v-flex class="pl-4" xs9>
                    <app-widget-group title="Investments" :loading="loading.statistics">
                        <v-layout>
                            <v-flex xs4>
                                <app-widget-performance
                                    :title="$t('new_investments_this_year')"
                                    :value="
                                        toCurrency(
                                            readStat('investments.new.current.amount', 0),
                                            readStat('investments.new.current.currency', 'GBP'),
                                            0,
                                            true
                                        )
                                    "
                                    :aside="[
                                        `${toPercentage(readStat('investments.new.month', 0), 0)} ${$t('this_month')}`
                                    ]"
                                    :outlined="false"
                                    label-bottom
                                    remove-padding
                                    :loading="loading.statistics"
                                />
                            </v-flex>
                            <v-flex xs4>
                                <app-widget-performance
                                    :title="$t('assets_onboarded_this_year')"
                                    :value="
                                        toCurrency(
                                            readStat('investments.assets_onboarded.current.amount', 0),
                                            readStat('investments.assets_onboarded.current.currency', 'GBP'),
                                            0,
                                            true
                                        )
                                    "
                                    :aside="[
                                        `${toPercentage(readStat('investments.assets_onboarded.month', 0), 0)} ${$t(
                                            'this_month'
                                        )}`
                                    ]"
                                    :outlined="false"
                                    label-bottom
                                    remove-padding
                                    :loading="loading.statistics"
                                />
                            </v-flex>
                            <v-flex xs4>
                                <app-widget-performance
                                    :title="$t('assets_being_onboarded')"
                                    :value="
                                        toCurrency(
                                            readStat('investments.assets_being_onboarded.amount', 0),
                                            readStat('investments.assets_being_onboarded.currency', 'GBP'),
                                            0,
                                            true
                                        )
                                    "
                                    :aside="[]"
                                    :outlined="false"
                                    label-bottom
                                    remove-padding
                                    :loading="loading.statistics"
                                />
                            </v-flex>
                        </v-layout>
                    </app-widget-group>
                </v-flex>
            </v-layout>
        </template>
        <template #widget-1>
            <app-widget-group :title="$t('clients')" :loading="loading.statistics">
                <v-layout>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('client_platform_accounts')"
                            :value="toNumber(readStat('clients.platform_accounts.current', 0))"
                            :aside="[
                                `${toPercentage(readStat('clients.platform_accounts.month', 0), 0)} ${$t('this_month')}`
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('authorised_investment_accounts')"
                            :value="toNumber(readStat('clients.investment_accounts.current', 0))"
                            :aside="[
                                `${toPercentage(readStat('clients.investment_accounts.month', 0), 0)} ${$t(
                                    'this_month'
                                )}`
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('account_apps_in_progress')"
                            :value="toNumber(readStat('clients.apps_in_progress', 0))"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('awaiting_signatures')"
                            :value="toNumber(readStat('clients.awaiting_signatures', 0))"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                </v-layout>
            </app-widget-group>
        </template>
        <template #widget-2>
            <app-widget-group :title="$t('applications')" :loading="loading.statistics">
                <v-layout>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('shortlists_created')"
                            :value="toNumber(readStat('applications.shortlists_created.number', 0))"
                            :aside="[
                                toCurrency(
                                    readStat('applications.shortlists_created.value.amount', 0),
                                    readStat('applications.shortlists_created.value.currency', 'GBP'),
                                    0,
                                    true
                                )
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('proposed_investments')"
                            :value="toNumber(readStat('applications.proposed_investments.number', 0))"
                            :aside="[
                                toCurrency(
                                    readStat('applications.proposed_investments.value.amount', 0),
                                    readStat('applications.proposed_investments.value.currency', 'GBP'),
                                    0,
                                    true
                                )
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('awaiting_signatures')"
                            :value="toNumber(readStat('applications.awaiting_signatures.number', 0))"
                            :aside="[
                                toCurrency(
                                    readStat('applications.awaiting_signatures.value.amount', 0),
                                    readStat('applications.awaiting_signatures.value.currency', 'GBP'),
                                    0,
                                    true
                                )
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('awaiting_funds')"
                            :value="toNumber(readStat('applications.awaiting_funds.number', 0))"
                            :aside="[
                                toCurrency(
                                    readStat('applications.awaiting_funds.value.amount', 0),
                                    readStat('applications.awaiting_funds.value.currency', 'GBP'),
                                    0,
                                    true
                                )
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                </v-layout>
            </app-widget-group>
        </template>
        <template #widget-3>
            <app-widget-group class="primaryLight" :loading="loading.statistics">
                <v-layout>
                    <v-flex xs4>
                        <app-widget-value
                            :title="$t('client_profiles_incomplete')"
                            :value="toNumber(readStat('profiles_incomplete', 0))"
                            :outlined="false"
                            label-bottom
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs4>
                        <app-widget-value
                            :title="$t('account_health')"
                            :value="readStat('account_health', '-')"
                            :outlined="false"
                            label-bottom
                            color="success darken-1"
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs4>
                        <app-widget-value
                            :title="$t('last_login')"
                            :value="[last_login_date, last_login_time]"
                            :max-size="30"
                            :outlined="false"
                            label-bottom
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <!-- <v-flex xs3>
                        <app-widget-performance
                            :title="$t('notifications')"
                            :value="toNumber(readStat('notification'))"
                            :outlined="false"
                            label-bottom
                            :loading="loading.statistics"
                        />
                    </v-flex> -->
                </v-layout>
            </app-widget-group>
        </template>
        <template #widget-4>
            <app-widget-timeline :outlined="false" dense :loading="loading.activity" :events="events" />
        </template>
    </layout-dashboard-2>
</template>

<script>
import get from 'lodash/get';
import toDate from '@/lib/helpers/toDate';
import StatisticApi from '@/api/StatisticApi';
import { Activity } from '@/models';

export default {
    name: 'AdviserDashboard',
    components: {
        LayoutDashboard2: () =>
            import(
                /* webpackChunkName: "layouts" */
                '@/components/layouts/LayoutDashboard2'
            ),
        AppWidgetGroup: () =>
            import(
                /* webpackChunkName: "widgets" */
                '@/components/widgets/AppWidgetGroup'
            ),
        AppWidgetTimeline: () =>
            import(
                /* webpackChunkName: "widgets" */
                '@/components/widgets/AppWidgetTimeline'
            ),
        AppWidgetPerformance: () =>
            import(
                /* webpackChunkName: "widgets" */
                '@/components/widgets/AppWidgetPerformance'
            ),
        AppWidgetValue: () =>
            import(
                /* webpackChunkName: "widgets" */
                '@/components/widgets/AppWidgetValue'
            )
    },
    data: () => ({
        statistics: null,
        events: [],
        loading: {
            statistics: true,
            activity: true
        }
    }),
    computed: {
        last_login() {
            let ll = this.readStat('last_login');
            if (ll) {
                ll += '+0000';
            }
            return toDate(ll, 'DD/MM/YYYY HH:mm:ss');
        },
        last_login_date() {
            if (this.last_login) {
                return this.last_login.split(' ')[0];
            }

            return '-';
        },
        last_login_time() {
            if (this.last_login) {
                return this.last_login.split(' ')[1];
            }

            return '-';
        }
    },
    methods: {
        async setup() {
            this.getStatistics();
            this.getActivity();
        },
        async getStatistics() {
            this.loading.statistics = true;

            try {
                const statistics = await new StatisticApi().methods.get('dashboards');
                this.statistics = statistics.data;
            } catch (error) {
                if (error?.code !== 404) {
                    this.handleError(error, this.getStatistics);
                }
            }

            this.loading.statistics = false;
        },
        async getActivity() {
            this.loading.activity = true;

            try {
                const activity = await Activity.api.index(0, 100, ['date:desc'], {
                    scope: this.getFilterOperator('is') + ':GLOBAL'
                });

                if (activity && 'data' in activity) {
                    this.events = activity.data;
                }
            } catch (error) {
                this.handleError(error, this.getActivity);
            }

            this.loading.activity = false;
        },
        readStat(path, fallback = null) {
            return get(this.statistics, path) || fallback;
        }
    }
};
</script>
